export default function RiskHeatmapAll({
  counts = {}, // {'p1-i1':0, 'p2-i1':1, ...} 없으면 0 처리
  highZone = 5,
  newThisWeek = 3,
  dueSoon = 7,
  onCellClick,
}: {
  counts?: Record<string, number>;
  highZone?: number;
  newThisWeek?: number;
  dueSoon?: number;
  onCellClick?: (p:number,i:number)=>void;
}) {
  const P=[1,2,3,4,5], I=[5,4,3,2,1];
  const val = (p:number,i:number)=> counts[`p${p}-i${i}`] ?? 0;
  const color = (n:number)=> n<=0?'bg-gray-50':n<=2?'bg-yellow-200':n<=4?'bg-orange-300':'bg-red-500 text-white';
  return (
    <div className="rounded-2xl border bg-white p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-medium">Risk Heatmap</h2>
        <div className="flex gap-2 text-xs">
          <span className="px-2 py-0.5 rounded bg-red-100 text-red-800">High-zone {highZone}</span>
          <span className="px-2 py-0.5 rounded bg-blue-100 text-blue-800">New {newThisWeek}</span>
          <span className="px-2 py-0.5 rounded bg-amber-100 text-amber-800">Due≤7d {dueSoon}</span>
        </div>
      </div>
      <div className="mt-3 flex gap-2 items-start">
        <div className="pt-6 text-[10px] text-gray-500 rotate-[-90deg] origin-top-left translate-y-[54px]">Impact ↑</div>
        <div className="flex-1">
          <div className="grid grid-cols-5 gap-1">
            {P.map(p=><div key={`xl${p}`} className="text-center text-[10px] text-gray-600">P{p}</div>)}
          </div>
          <div className="mt-1 grid grid-rows-5 gap-1">
            {I.map(i=>(
              <div key={`row${i}`} className="grid grid-cols-5 gap-1">
                {P.map(p=>{
                  const n = val(p,i);
                  return (
                    <button
                      key={`c${p}-${i}`}
                      className={`h-10 rounded-md border ${color(n)} flex items-center justify-center`}
                      title={`P${p}×I${i}: ${n}`}
                      onClick={()=>onCellClick?.(p,i)}
                    >
                      <span className="text-sm font-medium">{n}</span>
                    </button>
                  );
                })}
              </div>
            ))}
          </div>
          <div className="mt-2 text-[10px] text-gray-500 text-right">Probability →</div>
        </div>
      </div>
    </div>
  );
}
